import React, { createContext, useContext, useState } from "react";

const TransactionContext = createContext(undefined);
export const TransactionProvider = ({
  children,
}) => {
    const [transactions, settransactions] = useState([]);
    return (
        <TransactionContext.Provider
        value={{
            transactions,
            settransactions
        }}
        >
            {children}
        </TransactionContext.Provider>
    );
};
export const useTransactionContext = () => {
  const context = useContext(TransactionContext);
  if (!context) {
    throw new Error("useTransactionContext must be used within a TransactionProvider");
  }
  return context;
};